<template>
  <div class="rule-table">
    <el-table :data="tableData" key="ruleTable" border height="calc(100% - 18px)">
      <el-table-column
        v-for="column in tableColumns"
        :key="Math.random() + column.id"
        :prop="column.id"
        :label="column.name"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { previewChartData } from "@/api/bi"

export default {
  name: "rule-table",
  props: {
    rule: Object
  },
  data() {
    return {
      tableColumns: [],
      tableData: []
    }
  },
  methods: {
    init(rule) {
      if (this._.isEmpty(rule.yAxisList)) {
        this.$message.error("未设置指标数据")
        return
      }
      this.tableColumns = rule.xAxisList.concat(rule.yAxisList)
      this.getTableData(rule)
    },
    getTableData(rule) {
      rule.canSeeAll = false
      return previewChartData(rule, null).then(res => {
        this.tableData = res
        this.rule.isShow = true
        return res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-table {
  .el-table {
    width: 96%;
    margin-left: 18px;
  }
}
</style>
